import { useEffect, useState } from "react";
import { FiChevronLeft, FiChevronRight, FiFileText, FiFilter } from 'react-icons/fi';
import { FaClipboardList } from 'react-icons/fa';
import axios from "axios";

const TransactionsPage = () => {
  const [allTransactions, setAllTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [lastPage, setLastPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [employeeOptions, setEmployeeOptions] = useState([]);

  // Filter State
  const [filters, setFilters] = useState({
    employee_id: "",
    start_date: "",
    end_date: "",
    start_amount: "",
    end_amount: "",
  });

  const token = localStorage.getItem("token");

  const fetchTransactions = async () => {
    try {
      const role = localStorage.getItem('role');
      const managerOutletId = localStorage.getItem('id_outlet');
      const outletQueryParam = role === 'manager' && managerOutletId
        ? `&outlet_id=${managerOutletId}`
        : '';

      const {
        employee_id,
        start_date,
        end_date,
        start_amount,
        end_amount
      } = filters;

      const filterParams = `
        ${employee_id ? `&employee_id=${employee_id}` : ''}
        ${start_date ? `&start_date=${start_date}` : ''}
        ${end_date ? `&end_date=${end_date}` : ''}
        ${start_amount ? `&start_amount=${start_amount}` : ''}
        ${end_amount ? `&end_amount=${end_amount}` : ''}
      `.replace(/\s+/g, '');

      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/transaction?page=${page}&per_page=${perPage}${outletQueryParam}${filterParams}`;

      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const json = await res.json();

      if (Array.isArray(json.data)) {
        setAllTransactions(json.data);
        setLastPage(json.meta.last_page);
        setTotalData(json.meta.total);
      } else {
        setAllTransactions([]);
      }
    } catch (err) {
      console.error("Error fetching transactions:", err);
    }
  };
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/employee?role=employee`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setEmployeeOptions(response.data.data); // sesuaikan jika struktur API berbeda
      } catch (error) {
        console.error("Failed to fetch employees:", error);
      }
    };
  
    fetchEmployees();
  }, []);
  
  const fetchTransactionDetail = async (code) => {
    try {
      const encodedCode = encodeURIComponent(code);
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/transaction/${encodedCode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) throw new Error("Gagal mengambil detail transaksi");

      const data = await res.json();

      if (data && data.data) {
        setSelectedTransaction(data.data);
        setShowModal(true);
      }
    } catch (err) {
      console.error("❌ Error ambil detail:", err.message);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [page]);

  useEffect(() => {
    setPage(1);
  }, [search]);

  const filtered = allTransactions.filter((trx) =>
    trx.code?.toLowerCase().includes(search.toLowerCase())
  );

  const totalFilteredPages = Math.ceil(filtered.length / perPage);
  const validPage = Math.min(page, totalFilteredPages || 1);
  const paginated = filtered.slice((validPage - 1) * perPage, validPage * perPage);

 return (
 <div className="p-6 bg-white to-green-50 min-h-screen rounded-2xl">
      {/* Breadcrumb */}
            <nav className="text-gray-500 text-sm mb-3">
              <ol className="flex items-center gap-2">
                <li className="hover:text-gray-700 transition">Transactions</li>
              </ol>
            </nav>
      {/* Title */}
      <h2 className="text-3xl font-bold text-gray-800 mb-4 tracking-tight flex items-center gap-2">
              <span className="text-green-600 text-3xl"> 
                <div className="p-3 bg-green-100 rounded-2xl shadow-inner">
                <FaClipboardList className="text-green-600" />
                </div>
                </span> Transactions
                
            </h2>
            <p className="text-gray-600">Daftar transaksi yang sudah di lakukan</p>
            <br></br>

    {/* HEADER + SEARCH + FILTER */}
    <div className="mb-6 flex flex-wrap items-center gap-4">
      <input
        type="text"
        placeholder="Cari berdasarkan kode transaksi..."
        className="border border-gray-300 px-4 py-3 rounded-xl w-full max-w-md focus:outline-none focus:ring-2 focus:ring-blue-400 shadow-sm"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(1);
        }}
      />
      <button
        onClick={() => setShowFilter(true)}
        className="flex items-center gap-2 px-4 py-3 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700 transition transform active:scale-95"
      >
        <FiFilter />
        Filter
      </button>
    </div>

    {/* TABLE */}
    <div className="overflow-x-auto rounded-2xl border border-gray-200 shadow-sm">
              <table className="min-w-full bg-white rounded-2xl">
                <thead className="bg-green-50">
                  <tr>
            <th className="border-b px-4 py-3">Kode</th>
            <th className="border-b px-4 py-3">Kasir</th>
            <th className="border-b px-4 py-3">Tanggal</th>
            <th className="border-b px-4 py-3 text-right">Tuslah</th>
            <th className="border-b px-4 py-3 text-right">Embalase</th>
            <th className="border-b px-4 py-3 text-right">Total</th>
            <th className="border-b px-4 py-3 text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {paginated.length > 0 ? (
            paginated.map((trx) => (
              <tr key={trx.id} className="hover:bg-gray-50 transition">
                <td className="border-b px-4 py-2">{trx.code}</td>
                <td className="border-b px-4 py-2">{trx.created_by}</td>
                <td className="border-b px-4 py-2">
                  {new Date(trx.created_at).toLocaleString("id-ID")}
                </td>
                <td className="border-b px-4 py-2 text-right">
                  Rp {trx.tuslah?.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td className="border-b px-4 py-2 text-right">
                  Rp {trx.embalase?.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td className="border-b px-4 py-2 text-right">
                  Rp {trx.amount?.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td className="border-b px-4 py-2 text-center">
                  <button
                    onClick={() => fetchTransactionDetail(trx.code)}
                    className="flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition transform active:scale-95"
                  >
                    <FiFileText className="inline-block" />
                    Lihat Struk
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center py-6 text-gray-500">
                Tidak ada data.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    {/* PAGINATION */}
    <div className="flex flex-col md:flex-row justify-between items-center mt-6 gap-3">
      <p className="text-sm text-gray-500">
        Menampilkan {filtered.length} dari total {totalData} transaksi
      </p>
      <div className="flex items-center space-x-2">
        <button
          className="flex items-center px-4 py-2 bg-green-100 hover:bg-green-200 text-gray-700 rounded-xl shadow transition disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
        >
          <FiChevronLeft className="mr-2" />
          Prev
        </button>
        <span className="text-sm text-gray-600">
          Halaman <strong>{page}</strong> dari <strong>{lastPage}</strong>
        </span>
        <button
          className="flex items-center px-4 py-2 bg-green-100 hover:bg-green-200 text-gray-700 rounded-xl shadow transition disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => setPage((prev) => Math.min(prev + 1, lastPage))}
          disabled={page === lastPage}
        >
          Next
          <FiChevronRight className="ml-2" />
        </button>
      </div>
    </div>

    {/* MODAL STRUK */}
    {showModal && selectedTransaction && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-md w-full font-mono text-sm">
          <div className="text-center mb-4">
            <div className="font-semibold text-xl">APOTEK DJAYA MEDICA</div>
            <div>{selectedTransaction.outlet_name}</div>
            <div>{selectedTransaction.outlet_phone || "-"}</div>
          </div>
          <hr className="my-2 border-t border-dashed border-gray-400" />
          <div>Code: {selectedTransaction.code}</div>
          <hr className="my-2 border-t border-dashed border-gray-400" />
          <div>Kasir: {selectedTransaction.created_by}</div>
          <hr className="my-2 border-t border-dashed border-gray-400" />
          <div className="whitespace-pre-wrap mt-2">
            {selectedTransaction.items.map((item) => (
              <div key={item.id} className="flex justify-between py-1">
                <span>{item.name.toUpperCase()}</span>
                <span>{item.qty} x Rp {item.price.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                <span>= Rp {item.subtotal.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
            ))}
          </div>
          <hr className="my-2 border-t border-dashed border-gray-400" />
          <div className="flex justify-between py-1">
            <span>Total Item</span>
            <span>{selectedTransaction.total_item} / Rp {selectedTransaction.total.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          </div>
          <hr className="my-2 border-t border-dashed border-gray-400" />
          <div className="text-center mt-2">
            <div>
              Tgl: {new Date(selectedTransaction.created_at).toLocaleString("id-ID", { dateStyle: "short", timeStyle: "short" })}
            </div>
            <div>v1.0</div>
            <div className="mt-1 font-semibold">Terima Kasih</div>
          </div>
          <div className="mt-4 flex justify-center">
            <button
              onClick={() => setShowModal(false)}
              className="bg-red-500 text-white px-4 py-2 rounded-xl hover:bg-red-600 shadow transition transform active:scale-95"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    )}

    {/* MODAL FILTER */}
    {showFilter && (
      <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
        <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-md w-full">
          <h2 className="text-lg font-semibold mb-4">Filter Transaksi</h2>
          <div className="space-y-3">
            <select
              className="w-full border px-4 py-2 rounded-xl"
              value={filters.employee_id}
              onChange={(e) => setFilters({ ...filters, employee_id: e.target.value })}
            >
              <option value="">Pilih Employee</option>
              {employeeOptions.map((employee) => (
                <option key={employee.id} value={employee.id}>{employee.full_name}</option>
              ))}
            </select>
            <input
              type="date"
              className="w-full border px-4 py-2 rounded-xl"
              value={filters.start_date}
              onChange={(e) => setFilters({ ...filters, start_date: e.target.value })}
            />
            <input
              type="date"
              className="w-full border px-4 py-2 rounded-xl"
              value={filters.end_date}
              onChange={(e) => setFilters({ ...filters, end_date: e.target.value })}
            />
            <input
              type="number"
              className="w-full border px-4 py-2 rounded-xl"
              placeholder="Start Amount"
              value={filters.start_amount}
              onChange={(e) => setFilters({ ...filters, start_amount: e.target.value })}
            />
            <input
              type="number"
              className="w-full border px-4 py-2 rounded-xl"
              placeholder="End Amount"
              value={filters.end_amount}
              onChange={(e) => setFilters({ ...filters, end_amount: e.target.value })}
            />
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={() => setShowFilter(false)}
              className="px-4 py-2 bg-gray-300 rounded-xl hover:bg-gray-400 transition"
            >
              Batal
            </button>
            <button
              onClick={() => { setPage(1); fetchTransactions(); setShowFilter(false); }}
              className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
            >
              Terapkan
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
);

};

export default TransactionsPage;
